export default "__VITE_ASSET__Cqzmmb9V__"